// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3WRPc","noInteraction":"EventWrapper_noInteraction__3sPr1","pointerPassthrough":"EventWrapper_pointerPassthrough__1-UCc"};